export default __webpack_public_path__ + "static/media/stripe.eff7acc6.ico";